import { useMemo } from "react"
import { ICurrency } from "@/store/apis/balanceAPI"
import { useGetLabrUserBalanceQuery } from "@/store/apis/userAPI"

export const useMoneyEnough = (amount: number, currency: ICurrency) => {
  const { data: balance } = useGetLabrUserBalanceQuery()

  const isMoneyEnough = useMemo(() => {
    if (!balance) return false

    return balance[currency] >= amount
  }, [amount, currency, balance])

  return isMoneyEnough
}
